var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import ChevronRight from "../atoms/icons/ChevronRight";
import IdealLogo from "../atoms/icons/IdealLogo";
import { getAppThemeName } from "../../../services/appTheme";
const StyledIdealButton = styled.button `
  position: relative;
  background-color: ${props => props.theme.ideal};
  color: ${color.body.base};
  padding: 20px 35px 20px 60px;
  font-size: ${props => props.size === "small" ? "14px" : "16"};
  font-family: ${props => props.theme.fontBase};
  font-weight: 600;
  border: none;
  border-radius: 10px;
  outline: none;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  text-align: left;
  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.6;
    cursor: default;
    pointer-events: none;

    &:hover {
      background-color: ${props => props.theme.ideal};
    }
  }

  &:hover {
    background-color: ${props => props.theme.idealHover};
  }

  &:focus {
    outline: none;
  }

  &:before {
    ${props => props.appThemeName === "inkassier" && css `
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: -40px;
      bottom: -1px;
      width: 340px;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk0IiBoZWlnaHQ9Ijc2IiB2aWV3Qm94PSIwIDAgMjk0IDc2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIC4wMTF2NzUuMTY3aDE3NC4yMzZjNi45My0uNTE3IDI1LjI0MS0zLjEzNCAzOS43LTE2LjM1MSAwIDAgNTIuNjIzLTQ3LjI2NCA1NS45MjctNTAuMjExQzI4MC43MTYtLjY4MSAyOTQuMjc1LjAxMyAyOTQuMzU0LjAxMUgweiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBvcGFjaXR5PSIuMTU4Ii8+PC9zdmc+);
      background-size: cover;
      background-repeat: no-repeat;
    `};
  }

  ${props => props.theme.name === 'invoned' &&
    css `
      color: #2d073f;
      font-weight: 700;
      font-size: 16px;
      background-color: #ffc600;
    `}

  @media only screen and (min-width: 370px) {
    padding: ${props => props.variant === "transparent" ? "20px 45px 20px 60px" : "20px 45px 20px 80px"};
    font-size: ${props => props.size === "small" ? "14px" : "18px"};
  }

  @media only screen and (min-width: 576px) {
    padding: ${props => props.variant === "transparent" ? "20px 45px 20px 75px" : "20px 45px 20px 100px"};
  }
`;
const Ideal = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 50px;
  background-color: ${props => props.variant === "transparent" ? "transparent" : color.body.base};
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

  @media only screen and (min-width: 370px) {
    width: 60px;
  }

  @media only screen and (min-width: 576px) {
    width: 80px;
  }
`;
const StyledIdealLogo = styled(IdealLogo) `
  width: 28px;
  height: 28px;

  @media only screen and (min-width: 370px) {
    width: 32px;
    height: 32px;
  }

  @media only screen and (min-width: 576px) {
    width: ${props => props.size === "small" ? "32px" : "44px"};
    height: ${props => props.size === "small" ? "32px" : "44px"};
  }
`;
const StyledChevronRight = styled(ChevronRight) `
  fill: ${color.body.base};
  width: 8px;
  height: 14px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;

  @media only screen and (min-width: 576px) {
    width: ${props => props.size === "small" ? "8px" : "10px"};
    height: ${props => props.size === "small" ? "14px" : "18px"};
    
  }
`;
const IdealButton = (_a) => {
    var { children, variant, loading, size } = _a, props = __rest(_a, ["children", "variant", "loading", "size"]);
    return (React.createElement(StyledIdealButton, Object.assign({ appThemeName: getAppThemeName(), isLoading: !!loading, variant: variant, size: size }, props),
        React.createElement(Ideal, { variant: variant },
            React.createElement(StyledIdealLogo, { size: size })),
        children,
        React.createElement(StyledChevronRight, { size: size })));
};
export default IdealButton;
